import React, { Component } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Account from "./Pages/Accounts";
import Users from "./Pages/Users";
import UserView from "./Pages/UserView";
import Login from "./Pages/Login";
import { LogOut } from "./Pages/LogOut";
import Devices from "./Pages/Devices";
import MaicIntegration from "./Pages/MaicIntegration";
import AccountManagements from "./Pages/AccountManagements";
import ServerSettings from "./Pages/ServerSettings";
import AccountSettings from "./Pages/AccountSettings";
import SystemLogs from "./Pages/SystemLogs";
import ActionLogs from "./Pages/ActionLogs";
import RoleManagement from "./Pages/Role";
import ContractManagment from "./Pages/ContractManagment";
import Invoice from "./Pages/Invoice";
import GarageInvoices from "./Pages/GarageInvoices";
import GarageInvoiceView from "./Pages/GarageInvoices/GarageInvoiceView";
import ProcessInvoices from "./Pages/ProcessInvoices";
import DeliveryNote from "./Pages/DeliveryNote";
import Plans from "./Pages/Plans";
import NewPayment from "./Pages/NewPayment";
import WorkShopPayment from "./Pages/WorkshopPayment";
import ActivationCode from "./Pages/ActivationCode";
import TemplateGenerator from "./Pages/TemplateGenerator";
import Trash from "./Pages/Trash";
import Coupon from "./Pages/Coupon";
import WebHooks from "./Pages/WebHooks";
import NotFoundPage from "./Pages/NotFound";
import "react-toastify/dist/ReactToastify.css";

import "./assets/main.scss";
import "./Pages/Invoice/invoice-style.scss";
import InvoiceDetail from "./Pages/Invoice/Invoice";
import MaintenanceInvoiceDetail from "./Pages/Invoice/maintenanceInvoice";
import CashCustomerInvoiceDetail from "./Pages/Invoice/CashCustomerInvoiceDetail";
import MaintenanceInvoiceDetailGarage from "./Pages/GarageInvoices/maintenanceInvoice";
import DeliveryDetail from "./Pages/DeliveryNote/DeliveryNote";
import CreditDebit from "./Pages/CreditDebit";
import CreditNoteDetail from "./Pages/CreditDebit/CreditNoteDetail";
import DebitNoteDetail from "./Pages/CreditDebit/DebitNoteDetail";
import WorkshopPoDetail from "./Pages/PoRequest/WorkshopPoDetail";
import WorkshopPaymentDetail from "./Pages/WorkshopPayment/WorkshopPaymentDetail";
import Commutator from "./Pages/Commutator";
import Workshops from "./Pages/Workshops";
import Reports from "./Pages/Reports";
import Quotations from "./Pages/Quotation";
import QuotationDetail from "./Pages/Quotation/QuotationDetail";
import Vehicle from "./Pages/Vehicle";
import VehicleAssessment from "./Pages/VehicleAssessment";
import VehicleExpiry from "./Pages/VehicleExpiry";
import VehicleMakes from "./Pages/VehicleMakes";
import VehicleModels from "./Pages/VehicleModels";
import MaintenanceDashboard from "./Pages/MaintenanceDashboard";
import ExDashboard from "./Pages/ExDashboard";
import CcDashboard from "./Pages/CashDashboard";
import Payment from "./Pages/NewPayment/payment";
import MissingItems from "./Pages/MissingItems";
import ServiceMissingItems from "./Pages/ServiceMissingItems";
import MissedOpportunities from "./Pages/MissedOpportunities";
import UserPms from "./Pages/UserPms";
import Offers from "./Pages/Offers";
import B2C from "./Pages/B2C";
import Simah from "./Pages/Simah";
import ScheduleReportsAndNotifications from "./Pages/ScheduleReportsNotifications";
import Triggers from "./Pages/Triggers";
// import { withTranslation } from "react-i18next";
import i18n from "./i18n";

import { withTranslation } from "react-i18next";
import SalesDashboard from "./Pages/SalesDashboard";
import ServiceGuard from "./Pages/ServiceGuard";
import MannualInvoice from "./Pages/MannualInvoice";
import UnsyncedItems from "./Pages/UnsyncedItems";
import CRC from "./Pages/CRC";
import BusinessDashboard from "./Pages/BusinessDashboard";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      whiteLabling: "",
      callResponse: false,
      isDown: false,
      brandingCallInProcess: false,
    };

    // this.props.initialize({
    //   languages: [
    //     { name: "English", code: "en" },
    //     { name: "French", code: "fr" },
    //     { name: "Urdu", code: "ur" },
    //     { name: "Arabic", code: "ar" },
    //     { name: "Albanian", code: "sq" },
    //     { name: "Burmese", code: "my" },
    //     { name: "Chinese", code: "zh" },
    //     { name: "Central Khmer", code: "km" },
    //     { name: "German", code: "de" },
    //     { name: "Gujarati", code: "gu" },
    //     { name: "Hebrew", code: "he" },
    //     { name: "Hindi", code: "hi" },
    //     { name: "Hungarian", code: "hu" },
    //     { name: "Indonesian", code: "id" },
    //     { name: "Italian", code: "it" },
    //     { name: "Japanese", code: "ja" },
    //     { name: "Korean", code: "ko" },
    //     { name: "Mongolian", code: "mn" },
    //     { name: "Nepali", code: "ne" },
    //     { name: "Persian", code: "fa" },
    //     { name: "Portuguese", code: "pt" },
    //     { name: "Russian", code: "ru" },
    //     { name: "Serbian", code: "sr" },
    //     { name: "Spanish", code: "es" },
    //     { name: "Telugu", code: "te" },
    //     { name: "Thai", code: "th" },
    //     { name: "Turkish", code: "tr" },
    //     { name: "Amharic", code: "am" },
    //     { name: "Kurdish", code: "ku" },
    //   ],
    //   options: {
    //     renderToStaticMarkup: false,
    //     defaultLanguage: "en",
    //     onMissingTranslation,
    //   },
    // });

    // this.props.addTranslationForLanguage(en, "en");
    // this.props.addTranslationForLanguage(fr, "fr");
    // this.props.addTranslationForLanguage(urdu, "ur");
    // this.props.addTranslationForLanguage(arabic, "ar");
    // this.props.addTranslationForLanguage(albanian, "sq");
    // this.props.addTranslationForLanguage(burmese, "my");
    // this.props.addTranslationForLanguage(chinese, "zh");
    // this.props.addTranslationForLanguage(cambodian, "km");
    // this.props.addTranslationForLanguage(german, "de");
    // this.props.addTranslationForLanguage(gujarati, "gu");
    // this.props.addTranslationForLanguage(hebrew, "he");
    // this.props.addTranslationForLanguage(hindi, "hi");
    // this.props.addTranslationForLanguage(hungarian, "hu");
    // this.props.addTranslationForLanguage(indonesian, "id");
    // this.props.addTranslationForLanguage(italian, "it");
    // this.props.addTranslationForLanguage(japanese, "ja");
    // this.props.addTranslationForLanguage(korean, "ko");
    // this.props.addTranslationForLanguage(mongolian, "mn");
    // this.props.addTranslationForLanguage(nepali, "ne");
    // this.props.addTranslationForLanguage(persian, "fa");
    // this.props.addTranslationForLanguage(portuguese, "pt");
    // this.props.addTranslationForLanguage(russian, "ru");
    // this.props.addTranslationForLanguage(serbian, "sr");
    // this.props.addTranslationForLanguage(spanish, "es");
    // this.props.addTranslationForLanguage(telugu, "te");
    // this.props.addTranslationForLanguage(thai, "th");
    // this.props.addTranslationForLanguage(turkish, "tr");
    // this.props.addTranslationForLanguage(amharic, "am");
    // this.props.addTranslationForLanguage(kurdish, "ku");
  }

  componentWillMount() {
    this.fetchBranding();
  }
  setActiveLanguage = (lng) => {
    localStorage.setItem("SelectedLanguage", lng);
    i18n.changeLanguage(lng);
  };

  fetchBranding = () => {
    fetch(`/api/accounts/labeling?hostUrl=${window.location.host}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((res) => {
            if (res.status === "success") {
              this.setState({
                whiteLabling: res.data,
                callResponse: true,
                brandingCallInProcess: false,
              });
              document.title = res.data.serviceTitle;
              let domElements = document.getElementById("favicon");
              if (res.data && res.data.favIcon && domElements) {
                domElements.setAttribute("href", res.data.favIcon);
              }
            } else if (res?.statusCode === "440") {
              window.location.replace("/login");
            } else if (res.statusCode) {
              var err = res?.message.split(":");
              err[1] = err[1].replace(")", "");
              this.setState({
                callResponse: true,
              });
            } else {
              this.setState({
                callResponse: true,
                brandingCallInProcess: false,
              });
            }
          });
        } else {
          this.setState({
            callResponse: true,
          });
          console.log("Server is Down");
          throw response;
        }
      })
      .catch((e) => {
        this.setState({
          isDown: true,
          brandingCallInProcess: false,
        });
        console.log(e);
      });
  };

  render() {
    const { t } = this.props;
    return (
      <div>
        {this.state.callResponse ? (
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />

            <Route
              path="/triggers"
              element={
                <Triggers
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/schedule-Reports-And-Notifications"
              element={
                <ScheduleReportsAndNotifications
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/accounts"
              element={
                <Account
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/maintenance_dashboard"
              element={
                <MaintenanceDashboard
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/ex_dashboard"
              element={
                <ExDashboard
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            {/* <Route
              path="/cc_dashboard"
              element={
                <CcDashboard
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            /> */}
            <Route
              path="/sale_dashboard"
              element={
                <SalesDashboard
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/business_dashboard"
              element={
                <BusinessDashboard
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/offers"
              element={
                <Offers
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/accountSettings"
              element={
                <AccountSettings
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/users"
              element={
                <Users
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/b2c"
              element={
                <B2C
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/new_payment"
              element={
                <NewPayment
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/payment-detail"
              element={
                <Payment
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/new_payment/:id"
              element={
                <NewPayment
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/workshop-payment"
              element={
                <WorkShopPayment
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/workshop-payment/:id"
              element={
                <WorkShopPayment
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/vehicle"
              element={
                <Vehicle
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/vehicle-assessment/:id"
              element={
                <VehicleAssessment
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/vehicle-expiry"
              element={
                <VehicleExpiry
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/vehicle-expiry-due"
              element={<Navigate to="/vehicle-expiry" replace />}
            />
            <Route
              path="/vehicle-expiry-overdue"
              element={<Navigate to="/vehicle-expiry?tab=overdue" replace />}
            />
            <Route
              path="/vehicle-makes"
              element={
                <VehicleMakes
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/vehicle-models"
              element={
                <VehicleModels
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/users/view"
              element={
                <UserView
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/users/:id"
              element={
                <Users
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/users/edit/:userId"
              element={
                <Users
                  {...this.state}
                  addUserScreen={true}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/units"
              element={
                <Devices
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/units/:id"
              element={
                <Devices
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/maic-integration"
              element={
                <MaicIntegration
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/units/create/:userId"
              element={
                <Devices
                  {...this.state}
                  addUnitScreen={true}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/missing-items"
              element={
                <MissingItems
                  {...this.state}
                  addUnitScreen={true}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/service-missing-items"
              element={
                <ServiceMissingItems
                  {...this.state}
                  addUnitScreen={true}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/missed-opportunities"
              element={
                <MissedOpportunities
                  {...this.state}
                  addUnitScreen={true}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/user-pms"
              element={
                <UserPms
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/accountManagements"
              element={
                <AccountManagements
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/serverSettings"
              element={
                <ServerSettings
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/login"
              element={
                <Login
                  {...this.state}
                  setActiveLanguage={this.setActiveLanguage}
                  translate={t}
                />
              }
            />

            <Route
              path="/logout"
              element={
                <LogOut
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/systemLogs"
              element={
                <SystemLogs
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/actionLogs"
              element={
                <ActionLogs
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/roleManagement"
              element={
                <RoleManagement
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/roleManagement/:id"
              element={
                <RoleManagement
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/contractManagement"
              element={
                <ContractManagment
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/contractManagement/:id"
              element={
                <ContractManagment
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/invoice"
              element={
                <Invoice
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/garage-invoices/view"
              element={
                <GarageInvoiceView
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/garage-invoices"
              element={
                <GarageInvoices
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/process-invoices/*"
              element={
                <ProcessInvoices
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/mannual-invoice"
              element={
                <MannualInvoice
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/invoice/:id"
              element={
                <Invoice
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/invoiceDetail"
              element={
                <InvoiceDetail
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/maintenance-invoice-detail"
              element={
                <MaintenanceInvoiceDetail
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/cash-customer-invoice-detail"
              element={
                <CashCustomerInvoiceDetail
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/maintenance-invoice-detail-garage"
              element={
                <MaintenanceInvoiceDetailGarage
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/delivery-note"
              element={
                <DeliveryNote
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/service-guard"
              element={
                <ServiceGuard
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/unsynced-items"
              element={
                <UnsyncedItems
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/crc"
              element={
                <CRC
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/delivery-note/:id"
              element={
                <DeliveryNote
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/delivery-detail"
              element={
                <DeliveryDetail
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/plans"
              element={
                <Plans
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/activationCode"
              element={
                <ActivationCode
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/templateGenerator"
              element={
                <TemplateGenerator
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/trash"
              element={
                <Trash
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/coupon"
              element={
                <Coupon
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/commutator"
              element={
                <Commutator
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/credit_debit_notes"
              element={
                <CreditDebit
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/credit-note-detail"
              element={
                <CreditNoteDetail
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/debit-note-detail"
              element={
                <DebitNoteDetail
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/workshop-po-detail"
              element={
                <WorkshopPoDetail
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/workshop-payment-detail"
              element={
                <WorkshopPaymentDetail
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/workshops"
              element={
                <Workshops
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/reports"
              element={
                <Reports
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/simah"
              element={
                <Simah
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/quotation"
              element={
                <Quotations
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
            <Route
              path="/quotation-detail"
              element={
                <QuotationDetail
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="/webHooks"
              element={
                <WebHooks
                  {...this.state}
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />

            <Route
              path="*"
              element={
                <NotFoundPage
                  translate={t}
                  setActiveLanguage={this.setActiveLanguage}
                />
              }
            />
          </Routes>
        ) : null}
      </div>
    );
  }
}

export default withTranslation()(App);
